import JsonViewBase from '@uiw/react-json-view'
import { darkTheme } from '@uiw/react-json-view/dark'
import { lightTheme } from '@uiw/react-json-view/light'
import type { FC, HTMLAttributes } from 'react'
import { useColorScheme } from '../theme/use-color-scheme.js'

export interface JsonViewProps extends HTMLAttributes<HTMLDivElement> {
  value: object
}

export const JsonView: FC<JsonViewProps> = ({ value, ...rest }) => {
  const { colorScheme } = useColorScheme()
  return <JsonViewBase value={value} style={colorScheme === 'dark' ? darkTheme : lightTheme} {...rest} />
}
